export default "__VITE_ASSET__CXlagl00__"